import { useMemo } from 'react'

import {
    LinkBlocksWidgetLink,
    LinkBlocksWidgetType,
} from 'features/views/LayoutEditor/widgets/LinkBlocksWidget/types'
import {
    isEmptyLink,
    isInlineLink,
} from 'features/views/LayoutEditor/widgets/LinkBlocksWidget/utils'

import { useLinkBlocksWidgetLinkTargetState } from './useLinkBlocksWidgetLinkTargetState'

type LinkBlocksWidgetLinkListItemState = {
    style: LinkBlocksWidgetType['attrs']['style']
    link: LinkBlocksWidgetLink
    headerType: LinkBlocksWidgetType['attrs']['headerType']
}

export function useLinkBlocksWidgetLinkListItemState({
    style,
    link,
    headerType,
}: LinkBlocksWidgetLinkListItemState) {
    const { title, subtitle } = link

    const isInline = isInlineLink(link, headerType)
    const hasImageHeader = headerType === 'image'

    const hasSingleTextLabel = (!!title && !subtitle) || (!title && !!subtitle)
    const isEmpty = isEmptyLink(link)

    const isBoxed = style === 'boxed'
    const linkTarget = useLinkBlocksWidgetLinkTargetState(link)
    const renderAsLink = isBoxed && !linkTarget.shouldHide

    const to = renderAsLink && linkTarget.isUrlRelative ? linkTarget.url : undefined
    const href = renderAsLink && linkTarget.isUrlRelative ? undefined : linkTarget.url
    const target = renderAsLink ? linkTarget.target : undefined

    return useMemo(
        () => ({
            isInline,
            hasImageHeader,
            hasSingleTextLabel,
            isEmpty,
            renderAsLink,
            to,
            href,
            target,
        }),
        [isInline, hasImageHeader, hasSingleTextLabel, isEmpty, renderAsLink, to, href, target]
    )
}
